module.exports = __webpack_public_path__ + "static/img/18.73cd633.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/hearthstone/ranks/18.png
// module id = QRdU
// module chunks = 35